class GoogleSSO {
  constructor({ sdkUrl, scope, clientId }) {
    this.sdkUrl = sdkUrl;
    this.scope = scope;
    this.clientId = clientId;
  }

  prepare = () => {
    const { sdkUrl } = this;

    return new Promise((resolve, reject) => {
      const js = document.createElement('script');
      js.src = sdkUrl;
      js.onload = resolve;
      js.onerror = reject;
      document.head.appendChild(js);
    });
  };

  login = () => {
    const { clientId, scope } = this;
    return new Promise(resolve => {
      // eslint-disable-next-line no-undef
      this.codeClient = google.accounts.oauth2.initCodeClient({
        client_id: clientId,
        scope: scope,
        callback: resp => {
          resolve(resp);
        },
      });

      this.codeClient.requestCode();
    });
  };

  logout = () => {
    return new Promise(resolve => {
      // Nothing to do here, just log out.
      resolve();
    });
  };
}
export default GoogleSSO;
